import { FormElement } from '@vfde-brix/ws10/form-element';
import {
    InputFieldType,
    email,
    maxLength,
    onlyNumbers,
} from '@vfde-brix/ws10/validation';

// Custom validators
// validations that are too specific to be implemented as general solutions inside brix

/**
 * Accept dates and the string frühestmöglich
 */
export const dateValidator = (inputFields: InputFieldType[]): boolean => {
    const exceptionText = window.brixPageOptions?.exceptionTextForDate;
    const value = inputFields[0].value.trim();
    const regex = /^(?:(?:(?:0[1-9]|1\d|2[0-8])\.(?:0[1-9]|1[0-2])|(?:29|30)\.(?:0[13-9]|1[0-2])|31\.(?:0[13578]|1[02]))\.[1-9]\d{3}|29\.02(?:\.[1-9]\d(?:0[48]|[2468][048]|[13579][26])|(?:[2468][048]|[13579][26])00))$/g;

    return value === '' || regex.test(value) || exceptionText.trim().toLowerCase() === value.toLowerCase();
};

/**
 * Accept current and future dates and the string frühestmöglich
 */
export const pastDateValidator = (inputFields: InputFieldType[]): boolean => {
    const exceptionText = window.brixPageOptions?.exceptionTextForDate;
    const value = inputFields[0].value.trim();
    const [day, month, year] = value.split('.');
    const dateString = new Date([year, month, day].join('.'));
    const [currDateString] = new Date().toISOString().split('T');
    const currDate = new Date(currDateString);

    // Date objects can't be simply compared for equality => have to check the year, month and day
    const sameDay =
        dateString.getFullYear() === currDate.getFullYear() &&
        dateString.getMonth() === currDate.getMonth() &&
        dateString.getDate() === currDate.getDate();

    return value === '' || dateString > new Date(currDate) || sameDay || exceptionText.trim().toLowerCase() === value.toLowerCase();
};

/**
 * workaround for captcha field validation
 */
export const captchaValidator = (captchaInput: FormElement): void => {
    const newProps = captchaInput.getProperties();
    newProps.optState = 'error';
    captchaInput.update(newProps, true);
};

/**
 * customer can only add 50 characters
 * the error message is under brixPageOptions as maxLength50
 */
export const MAX_LENGTH_50 = {
    validator: maxLength,
    errorKey: 'maxLength50',
    maxLength: 50,
};

/**
 * customer can only add 70 characters
 * the error message is under brixPageOptions as maxLength70
 */
export const MAX_LENGTH_70 = {
    validator: maxLength,
    errorKey: 'maxLength70',
    maxLength: 70,
};

/**
 * customer can only add 80 characters
 * the error message is under brixPageOptions as maxLength80
 */
export const MAX_LENGTH_80 = {
    validator: maxLength,
    errorKey: 'maxLength80',
    maxLength: 80,
};

/**
 * customer must add a value with an e-mail format
 * the error message is under brixPageOptions as email
 */
export const EMAIL_FORMAT = {
    validator: email,
    errorKey: 'email',
};

/**
 * customer can only add numbers
 * the error message is under brixPageOptions as onlyNumbersCustomerNumber
 */
export const ONLY_NUMBERS = {
    validator: onlyNumbers,
    errorKey: 'onlyNumbersCustomerNumber',
};

/**
 * customer can only add a value with a date format
 * the error message is under brixPageOptions as dateFormat
 */
export const DATE_FORMAT = {
    validator: dateValidator,
    errorKey: 'dateFormat',
};

/**
 * customer cannot add dates that are in the past
 * the error message is under brixPageOptions as pastDate
 */
export const PAST_DATE = {
    validator: pastDateValidator,
    errorKey: 'pastDate',
};
